import {Component, Input, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'pt-widget-error',
  template: `
<!--    <div class='error-bar'>{{errorMessage}}</div>-->
  `,
  styles: [`
    .error-bar {
      padding: 5px 10px;
      margin: 0;
      background: #ffc107;
      color: white;
      font-weight: bold;
    }
  `]
})
export class WidgetErrorComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }
  @Input() errorMessage: string;
}
